
export const isMocaScaleKey = (scaleKey) =>
  typeof scaleKey === "string" && scaleKey.trim().toLowerCase() === "moca";

export const hasMocaAssessmentInput = (data) => {
  if (!data || typeof data !== "object") return false;
  if (String(data.comments ?? "").trim().length > 0) return true;

  const sectionScoreKeys = [
    "visual_executive",
    "naming",
    "memory",
    "attention",
    "language",
    "abstraction",
    "delayed_recall",
    "orientation",
  ];
  if (sectionScoreKeys.some((k) => Number(data[k]) > 0)) return true;

  const nestedKeys = [
    "visual_executive_data",
    "naming_data",
    "memory_data",
    "attention_data",
    "language_data",
    "abstraction_data",
    "delayed_recall_data",
    "orientation_data",
  ];

  const valueIsAnswer = (v) => {
    if (v === "yes" || v === "no") return true;
    if (Array.isArray(v) && v.length > 0) return true;
    if (typeof v === "string" && v.trim() !== "") return true;
    return false;
  };

  for (const nk of nestedKeys) {
    const obj = data[nk];
    if (!obj || typeof obj !== "object") continue;
    for (const v of Object.values(obj)) {
      if (valueIsAnswer(v)) return true;
    }
  }
  return false;
};
